var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManuallyAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7167 6.17467C15.9496 7.40755 15.9496 9.40646 14.7167 10.6393C13.4839 11.8722 11.4849 11.8722 10.2521 10.6393C9.01917 9.40646 9.01917 7.40755 10.2521 6.17467C11.4849 4.94178 13.4839 4.94178 14.7167 6.17467Z",
    stroke: "#40DA9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4291 15.009C15.2547 14.5398 13.8769 14.2812 12.4846 14.2812C8.82496 14.2812 5.25208 16.0596 5.25208 18.7944V19.6984C5.25208 20.1975 5.6571 20.6025 6.15614 20.6025H14.6661",
    stroke: "#40DA9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8123 23.3376C16.3162 23.3376 14.292 21.3143 14.292 18.8172C14.292 16.3726 16.3714 14.2942 18.816 14.2969C21.3112 14.2987 23.3327 16.322 23.3327 18.8172C23.3327 21.3134 21.3094 23.3376 18.8123 23.3376Z",
    fill: "#40DA9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8123 23.3376C16.3162 23.3376 14.292 21.3143 14.292 18.8172C14.292 16.3726 16.3714 14.2942 18.816 14.2969C21.3112 14.2987 23.3327 16.322 23.3327 18.8172C23.3327 21.3134 21.3094 23.3376 18.8123 23.3376",
    stroke: "#40DA9E",
    strokeWidth: 1.3561,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8225 17.8047L18.311 20.3162L16.8048 18.8091",
    stroke: "#F4F4F4",
    strokeWidth: 1.3561,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuallyAccepted);
export default __webpack_public_path__ + "static/media/manually_accepted.9d85058f6c0135707778d1ef5a849c09.svg";
export { ForwardRef as ReactComponent };